<template>
  <div class="verify-email-form-wrapper">
    <div class="div-block">
      <img
        src="@/assets/timeslot-images/animation_500_l3vkfkxp.gif"
        loading="lazy"
        width="170"
        alt=""
      />
      <div class="text-block">Successful</div>
      <div class="text-block-3">{{ message }}</div>
    </div>
    <div class="div-block">
      <!--      <a href="../customer/dashboard.html" class="button-2 w-button">Proceed</a>-->
      <FormulateInput type="submit" label="Proceed" @click="goToLogin" />
    </div>
    <div class="text-block-2">© {{ currentYear() }} Timeslate</div>
  </div>
</template>

<script>
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "TimeSlotSuccess",
  props: {
    message: String,
    buttonAction: Function
  },
  methods: {
    goToLogin() {
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.LOGIN);
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    }
  }
};
</script>

<style scoped></style>
